import {ReactNode, useContext, useEffect} from "react";
import {Container} from "@mantine/core";
import LayoutContext from "./_layout/LayoutContext";

type PageWrapperProps = {
    children?: ReactNode | ReactNode[];

    /**
     * Wraps your children inside a <Container mt="xl"> container.
     * @author Kacper Faber
     * @since 0.1.8
     * @example <PageWrapper container> ... </PageWrapper>
     */
    container?: boolean;

    /**
     * If set, will hide entire navbar and toggle button.
     * But we get back button.
     * @author Kacper Faber
     * @since 0.1.8
     */
    subPage?: boolean;
}

/**
 * Wraps page content inside a wrapper.
 * We can do some quick settings like current page.
 * @param props
 * @constructor
 * @author Kacper Faber
 * @since 0.1.1
 */
function PageWrapper(props: PageWrapperProps) {
    const layoutContext = useContext(LayoutContext);

    /**
     * Update subPage in layout context.
     * Returns an anonymous function to restore the subPage state.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const updateSubPage = () => {
        layoutContext.setIsSubPage(props.subPage === true);
        return () => layoutContext.setIsSubPage(false);
    }

    useEffect(updateSubPage, [props.subPage]);

    if (props.container) {
        return (
            <Container mt="xl">
                { props.children }
            </Container>
        );
    }

    return (
        <div>
            { props.children }
        </div>
    );
}

export default PageWrapper;